import React, { useEffect } from "react";
import { type OngoingCallView } from '../../models/mappers/ongoingCall';
import { formatUSPhoneNumber } from "../../utils/phoneNumberFormatting";

type OngoingCallsAccordionRowProps = {
  data: OngoingCallView;
};

export const OngoingCallsAccordionRow: React.ComponentType<OngoingCallsAccordionRowProps> = ({
  data
}) => {

  return (
    <>
      {data &&
        <div className="py-3 px-4 bg-gray-50 border-t border-gray-200" style={{ backgroundColor: "var(--grey-100)" }}>
          <div style={{ marginLeft: "40px" }}>

            <div className="row">
              <div className="col-xl-6 col-xs-12">
                <sup style={{ color: "var(--font-color-dark)" }}>Call-SId: {data.callSid ?? "-"}</sup>
              </div>
              <div className="col-xl-6 col-xs-12">
                <sup style={{ color: "var(--font-color-dark)" }}>Call-Id: {data.callId ?? "-"}</sup>
              </div>
            </div>

            <div className="row">
              <div className="mb-2 col-xl-6 col-xs-12">
                <div className="d-flex flex-column">
                  <div>
                    <h6 style={{ marginBottom: "4px", fontSize: "15px" }}>Operators in call</h6>
                    {data.operators && data.operators?.length > 0 ? (
                      <ul style={{ marginLeft: '1rem', listStyle: 'disc' }}>
                        {data.operators?.map((operator) => (
                          <li key={operator.operatorId} className="">
                            <span className="pr-4">{operator.operatorName ?? "_"}</span>
                            <span>{operator.operatorId}</span>
                          </li>
                        ))}
                      </ul>
                    ) :
                      (
                        <span>No operators</span>
                      )
                    }
                  </div>
                  <div className="mt-4 mb-4">
                    <h6 style={{ marginBottom: "4px", fontSize: "15px" }}>Outbound Calls (Added Participants)</h6>
                    {data.outboundPhoneNumbers && data.outboundPhoneNumbers?.length > 0 ? (
                      <>
                        {data.outboundPhoneNumbers?.map((participant) => (
                          <div key={participant}>
                            {formatUSPhoneNumber(participant)}
                          </div>
                        ))}
                      </>
                    ) :
                      (
                        <span>No participants</span>
                      )
                    }
                  </div>
                </div>
              </div>

              <div className="col-6">
                <h6 style={{ marginBottom: "4px", fontSize: "15px" }}>Custom Input Fields</h6>
                {data.customInputFields && data.customInputFields?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-sm" >
                      <thead>
                        <tr>
                          <th scope="col">Type</th>
                          <th scope="col">Name</th>
                          <th scope="col">Value</th>
                          <th scope="col">Enabled</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.customInputFields?.map((field) => (

                          <tr key={field.name}>
                            <th scope="row">{field.criteriaType ?? "_"}</th>
                            <td className="overflow-clip-ellipsis mr-2" style={{ maxWidth: "200px", color: "var(--text-site)" }}>{field.name ?? "_"}</td>
                            <td className="mr-2" style={{ color: "var(--text-site)" }}>{field.value ?? "_"}</td>
                            <td style={{ maxWidth: "200px", color: "var(--text-site)" }}>{(field.isEnabled || field.isEnabled == null) ? "Yes" : "No"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                ) :
                  (
                    <p>No data</p>
                  )
                }

              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};
